const epaper = {
  landingPage: {
    heading: {
      1: 'Experience my life even more easily now',
      2: 'Subscribe now',
      3: 'Or get it at your local pharmacy',
      4: 'Find a my life pharmacy near you now',
      5: 'Get the latest editions now!',
    },
    iconBlock: {
      1: 'Always and everywhere well-informed about current health topics',
      2: 'Good for the environment - by reading the e-paper, you save paper!',
      3: 'Competent health journalism in “pharmacy-quality”',
    },
    cardBlock: {
      user: {
        1: 'Sign up for the free e-paper subscription.',
        2: 'Log in with your IhreApotheken customer credentials.',
        3: 'Receive the my life e-paper regularly via email and enjoy reading!',
      },
      guest: {
        1: 'Create an IhreApotheken.de account.',
        2: 'Activate the free subscription in your customer account.',
        3: 'Receive the latest edition of my life as an e-paper via email twice a month.',
      },
    },
    paragraph: {
      1: 'For everyone who wants to stay up-to-date on health & medicine, wellness & beauty, mindfulness, alternative healing methods, food & drink, home & garden, as well as lifestyle & travel anytime and anywhere, my life is now also available as a free digital e-paper.',
      2: 'New e-paper editions are published on the 2nd and 16th of each month.',
      3: 'You can get the my life magazine for free as a print edition at your local pharmacy. The print magazine is available on the 1st and 15th of each month at your pharmacy.',
      4: 'Find the my life magazine at your local pharmacy here.',
    },
    button: {
      subscribe: 'Subscribe now',
      toPharmacy: 'To the pharmacy',
    },
  },
  magazinePage: {
    heading: 'my life E-Paper',
    paragraph: 'Read all my life magazines digitally - anytime, anywhere. Click on the magazine preview to open the e-paper.',
    latestTitle: 'Latest Edition',
    editionOf: 'Edition of',
    archiveTitle: 'All Magazines',
    button: 'Read now',
    allMagazines: 'All Magazines',
    loadMore: 'Load more',
    emailNotificationHeading: 'E-Mail Notifications',
    emailNotificationText: 'I would like to be notified by email about the new edition of the my life magazine. My registration is voluntary and can be revoked at any time.',
    emailNotificationCheckboxText: 'E-Mail Notifications',
    emailNotificationSubtext: 'Here you can find our',
    privacyPolicy: 'Privacy Policy',
  },
  subscribeBlock: {
    heading: 'Subscribe to E-Paper',
    paragraph: 'You will receive the <strong>free</strong> e-paper on the 2nd and 16th of each month via a link sent to you by email.',
    list: {
      1: 'Current and relevant health topics available anytime and anywhere',
      2: 'Great special offers for readers',
      3: '<strong>Free</strong> in your pharmacy and online',
    },
    policy: {
      termsOfUse: 'Terms of Use',
      privacyPolicy: 'Privacy Policy',
      1: 'The',
      2: 'and',
      3: 'I have acknowledged and agree to their applicability.*',
    },
    pleaseFill: '* Please fill in the required fields',
    button: 'Subscribe for free',
  },
  successPage: {
    subscribe: {
      heading: 'Subscription Completed',
      alertText: 'You have successfully subscribed to the my life e-paper. You will now receive the my life e-paper regularly via email.',
      button: {
        toMagazine: 'To the magazines',
        toMyAccount: 'To the customer account',
      },
    },
    epaperRegister: {
      heading: 'Registration & Subscription Completed',
      alertText: 'You have successfully created your IhreApotheken.de customer account and subscribed to the my life e-paper. An email has been sent to {email}. It contains a link that you need to click to confirm your account.',
    },
    register: {
      heading: 'Thank you for your registration',
      alertText: 'An email has been sent to {email}. It contains a link that you need to click to confirm your account.',
      button: 'To the homepage',
    },
    unsubscribe: {
      heading: 'Your my life e-paper subscription has been canceled',
      toHomepage: 'To the homepage',
      manageSubscription: 'Manage subscription',
    },
  },
  authentication: {
    description: 'Read all my life magazines digitally - anytime, anywhere. Simply log in with your IhreApotheken.de customer credentials and enjoy reading!',
    alert: {
      1: 'To read the my life e-paper and manage your subscription, a IhreApotheken customer account is required. Already have an account?',
      2: 'Log in',
    },
    checkbox: 'Subscribe to the {strongText} e-paper for free. Stay informed about all relevant health topics anytime, anywhere. Your registration is voluntary and can be revoked at any time.',
    myLife: 'myLife',
  },
}

export default epaper
